export const booleans = [
  { value: "true", label: "Yes" },
  { value: "false", label: "No" }
];

export const f0Methods = [
  { value: "pm", label: "PM" }, // Pitch Mark
  { value: "harvest", label: "Harvest" },
  { value: "crepe", label: "Crepe"},
  { value: "mangio-crepe", label: "Mangio Crepe"},
  { value: "rmvpe", label: "RMVPE"}, // Robust Model for Vocal Pitch Estimation (RMVPE)
];

export const f0MethodForValue = (key) => {
  var result = f0Methods.find(f0 => {
    return f0.value === key
  });

  return result?.label;
};

export const inferenceStatuses = [
  { value: "queued", label: "Queued" },
  { value: "processing", label: "Processing" },
  { value: "complete", label: "Complete"},
  { value: "error", label: "Error" },
  { value: "canceled", label: "Canceled" },
];

export const organizationStatuses = [
  { value: "active", label: "Active" },
  { value: "inactive", label: "Inactive" },
];

export const userStatuses = [
  { value: "active", label: "Active" },
  { value: "inactive", label: "Inactive" },
];

export const technologies = [
  { value: "v1", label: "v1" },
  { value: "v2", label: "v2" },
]

export const visibilityStatuses = [
  { value: "available", label: "Available" },
  { value: "unavailable", label: "Unavailable" },
]

export const optionForValue = (key, options) => {
  var result = options.find(option => {
    var value = option.value;
    if(option.value === "true" || option.value === "false") {
      value = JSON.parse(value);
    }
    return value === key;
  });

  return result;
}
